<p-toast></p-toast>
<app-loading *ngIf="loading"></app-loading>
<div>
  <router-outlet></router-outlet>
</div>
